import {numberToCorrectColor, numberToMarkColor} from "../Utils";

export default function getColGroupDocDefinition(
    printParams,
    agGridApi,
    aggregateLevelDepth,
    reportName
) {
  const {
    PDF_HEADER_COLOR,
    PDF_INNER_BORDER_COLOR,
    PDF_OUTER_BORDER_COLOR,
    PDF_ODD_BKG_COLOR,
    PDF_EVEN_BKG_COLOR,
    PDF_HEADER_HEIGHT,
    PDF_ROW_HEIGHT,
    PDF_PAGE_ORIENTATION,
    PDF_WITH_CELL_FORMATTING,
    PDF_WITH_COLUMNS_AS_LINKS,
    PDF_SELECTED_ROWS_ONLY,
    PDF_WITH_HEADER_IMAGE,
    PDF_WITH_FOOTER_PAGE_COUNT,
  } = printParams;

  const DEFAULT_ROW_HEIGHT = 20;

  const pdfMakeDefaultCol = {
    "text": "",
    // "style": "tableHeader",
    // "_margin": null,
    // "_inlines": [],
    // "_minWidth": 0,
    // "_maxWidth": 0
  }

  return (function() {
    const convertColDefToPdfMakeCell = (props)=>{
      const {col,rowSpan} = props;
      const pdfMakeCol = {...pdfMakeDefaultCol};
      pdfMakeCol.text = col.headerName;
      if(!col.hasOwnProperty('pinned')){
        pdfMakeCol.id = col.field;
      }
      pdfMakeCol.colId = col.colId;
      if(hasChildren(col)){
        pdfMakeCol.colSpan = countChildren(col);
      }
      if(rowSpan){
        pdfMakeCol.rowSpan = rowSpan;
        pdfMakeCol.marginTop = (aggregateLevelDepth-1)*DEFAULT_ROW_HEIGHT;
      }
      if(col.pdfExportOptions){
        Object.entries(col.pdfExportOptions).forEach(
            ([key, value]) => (pdfMakeCol[key] = value)
        );
      }
      return pdfMakeCol;
    }

    const countChildren = (col, amount = 0) => {
      if (hasChildren(col)) {
        for (let i = 0; i < col.children.length; i++) {
          const child = col.children[i];

          if (hasChildren(child)) {
            // If child has children, recursively count them
            amount = countChildren(child, amount);
          } else {
            // If child is a leaf node, increment the count
            amount++;
          }
        }
      }

      return amount;
    };

    const processNode = (col,depth,rows) => {
      rows[depth].push(convertColDefToPdfMakeCell({col:col}));
      if(hasChildren(col)){
        // Adds extra cells here so concept cells with colspan > 1 don't overwrite other concept headings cells
        for (let c = 0; c < countChildren(col) - 1; c++) {
          rows[depth].push({...pdfMakeDefaultCol});
        }

        depth++;
        for(let i = 0; i < col.children.length; i++){
          const child = col.children[i];
          processNode(child,depth,rows);
        }
      }
    };

    function hasChildren(node) {
      return node.children && node.children.length > 0;
    }

    const header = PDF_WITH_HEADER_IMAGE
        ? {
          // image: "ag-grid-logo",
          width: 150,
          alignment: "center",
          margin: [0, 10, 0, 10]
        }
        : null;

    const footer = PDF_WITH_FOOTER_PAGE_COUNT
        ? function(currentPage, pageCount) {
          return {
            fontSize: 10,
            text: currentPage.toString() + " of " + pageCount,
            margin: [10]
          };
        }
        : null;

    const pageMargins = [
      10,
      PDF_WITH_HEADER_IMAGE ? 70 : 10,
      10,
      PDF_WITH_FOOTER_PAGE_COUNT ? 20 : 10
    ];

    const A4_PAGE_DIMENSION = {
      width: 596,
      height: 842
    }

    const columnDefs = agGridApi.getColumnDefs();


    let headerRows = Array.from({ length: aggregateLevelDepth }, () => []);

    // const middleRows = [...rows];
    const pinnedRightHeaderRows = [];
    for(let i = 0; i < columnDefs.length; i++){
      const col = columnDefs[i];
      if(hasChildren(col)){
        headerRows[0].push(convertColDefToPdfMakeCell({col:col}));
        let depth = 1;
        for(let j = 0; j < col.children.length; j++){
          const child = col.children[j];
          processNode(child,depth,headerRows);
        }
        for(let j = 0; j < col.children.length-1; j++){
          headerRows[0].push({...pdfMakeDefaultCol});
        }
      }else{
        if(col.pinned === 'right'){
          pinnedRightHeaderRows.push(col);
        }else{
          for(let j = 0; j < aggregateLevelDepth; j++){
            if(j === 0){
              headerRows[j].push(convertColDefToPdfMakeCell({col:col, rowSpan:aggregateLevelDepth}));
            }else{
              if(j === aggregateLevelDepth-1){
                headerRows[j].push({text:'' ,id:col.field});
              }else{
                headerRows[j].push({text:''});
              }
            }
          }
        }
      }
    }

    /* START Add extra cells so that they all have the same length */
    let longestRow = 0;

    for(let i = 0; i < headerRows.length; i++){
      const row = headerRows[i];
      longestRow = Math.max(longestRow,row.length);
    }

    for(let i = 0; i < headerRows.length; i++){
      const row = headerRows[i];
      if(row.length < longestRow){
        const len = longestRow-row.length;
        for(let j = 0; j < len; j++){
          row.push({...pdfMakeDefaultCol})
        }
      }
    }
    /* END Add extra cells */

  for(let i = 0; i < pinnedRightHeaderRows.length; i++){
    const col = pinnedRightHeaderRows[i];
    for(let j = 0; j < aggregateLevelDepth; j++){
      if(j === 0){
        headerRows[j].push(convertColDefToPdfMakeCell({col:col, rowSpan:aggregateLevelDepth}));
        // headerRows[j].push(convertColDefToPdfMakeCell(col));
      }else{
        if(j === aggregateLevelDepth-1){
          headerRows[j].push({text:'' ,id:col.field});
        }else{
          headerRows[j].push({});
        }
      }
    }
  }

    const widths = [];

    for(let i = 0; i < (longestRow+pinnedRightHeaderRows.length); i++){
      widths.push('auto');
    }

    const bodyRows = [];

      agGridApi.forEachNode((rowNode, index) => {
        const bodyRow = [];
          headerRows[headerRows.length-1].forEach((row)=> {
              if (rowNode.data.hasOwnProperty(row.id)) {
                bodyRow.push(createTableCell(rowNode.data[row.id]));
              } else if (rowNode.data.hasOwnProperty(row.colId)) {
                bodyRow.push(createTableCell(rowNode.data[row.colId]));
              } else {
                bodyRow.push({text: ''});
              }
            });
          bodyRows.push(bodyRow);
      });

    const pageWidth = bodyRows[0].length * printParams.PDF_COLUMN_WIDTH;
    const body = [...headerRows, ...bodyRows];

    function createTableCell(cellValue){
      let backgroundColor = '',
          color = 'black';
      if (typeof cellValue === 'string' && cellValue[cellValue.length-1] === '%') {
        backgroundColor = numberToMarkColor(cellValue);
        color = 'white';
      }
      return {text: cellValue, fillColor:backgroundColor, color:color , alignment: 'center'};
    }
    const docDefintiion = {
      pageSize: {
        width: pageWidth > A4_PAGE_DIMENSION.height ? pageWidth : A4_PAGE_DIMENSION.height,
        height: A4_PAGE_DIMENSION.width,
        orientation: PDF_PAGE_ORIENTATION
      },
      header,
      footer,
      content: [
        {
          style: 'tableExample',
          fontSize: 10,
          color: '#444',
          table: {
            widths: widths,
            headerRows: headerRows.length,
            // keepWithHeaderRows: 1,
            body: body
          }
        },
      ],
      styles: {
        myTable: {
          margin: [0, 0, 0, 0]
        },
        tableHeader: {
          bold: true,
          margin: [0, PDF_HEADER_HEIGHT / 3, 0, 0]
        },
        tableCell: {
          border: [true, true, true, true],
        }
      },
      pageMargins
    };

    return docDefintiion;
  })();


}
